define.alias("shared/components/shared/social/instagram-modal", "media/components/shared/social/instagram-modal");